import { z } from "zod";

export const selfCertQSchema = z.string();

export type SelfCertQType = z.infer<typeof selfCertQSchema>;
